/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiElement from './lui-element'

export default class LuiTheme extends LuiElement {
  static get themeName() {
    return this.is.replace(/^lui-|-theme$/g, '').toLowerCase()
  }

  static get themeCss() {
    if (!this._themeCss) this._themeCss = this._generateThemeCss()
    return this._themeCss
  }

  static get addOwnCssToThemeCascade() {
    return true
  }

  static _generateThemeCss() {
    const styleElement = document.getElementById(`${this.is}-style`)
    let css = styleElement ? styleElement.innerText : ''
    css = css.replace(/($|\s|,|\})lui-\w+(-theme)?\{.+?\}/g, '$1')
    css = css.replace(/lui-\w+(-theme)? /g, '')
    return css
  }

  constructor() {
    super()
    const name = this.constructor.themeName
    const themes = window.lui.themes
    if (!themes[name]) {
      themes[name] = this.constructor
    }
    const themeCss = window.lui.themeCss
    if (!themeCss[name]) {
      themeCss[name] = this.constructor.themeCss
    }
  }

  connectedCallback() {
    const styles = window.getComputedStyle(this)
    const themeCascadeParent = styles.getPropertyValue('--lui-theme-cascade')
    const themeCascade = themeCascadeParent + '/' + this.constructor.themeName
    this.style.setProperty('--lui-theme-cascade', themeCascade)
    const themeCss = window.lui.themeCss
    if (!themeCss[themeCascade]) {
      const parentThemeCss = themeCss[themeCascadeParent]
      themeCss[themeCascade] = parentThemeCss + (this.constructor.addOwnCssToThemeCascade ? this.constructor.themeCss : '')
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-base/lui-theme.js
// module id = 10
// module chunks = 0 1 5 19